// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2IG1j","footer":"Form_footer__brg9l"};